import { Tabs as BaseTabs } from "@base-ui/react/tabs";
import type { ComponentProps } from "react";
import { cn } from "../utils";

export const Tabs = BaseTabs.Root;
export const TabsPanel = BaseTabs.Panel;

export function TabsList({
  className,
  children,
  ...props
}: ComponentProps<typeof BaseTabs.List>) {
  return (
    <BaseTabs.List
      className={cn(
        "relative inline-flex items-center gap-1 border-b border-line",
        className,
      )}
      {...props}
    >
      {children}
      <BaseTabs.Indicator
        className={cn(
          "absolute bottom-0 left-0 h-0.5 w-[var(--active-tab-width)] bg-ember",
          "translate-x-[var(--active-tab-left)] transition-[width,translate] duration-200 ease-swift",
        )}
      />
    </BaseTabs.List>
  );
}

export function TabsTab({
  className,
  ...props
}: ComponentProps<typeof BaseTabs.Tab>) {
  return (
    <BaseTabs.Tab
      className={cn(
        "cursor-pointer px-3 py-2 text-[0.8125rem] font-medium text-ink-muted outline-none",
        "transition-colors duration-150 hover:text-ink",
        "data-[selected]:text-ink",
        className,
      )}
      {...props}
    />
  );
}
